import { useSyncExternalStore } from 'react';

/**
 * compact(작은 화면) 경계 — `< lg(1024)` = compact. 반응형 일괄 breakpoint.
 *   - 필터: compact = 바텀시트(아이콘 버튼) / wide = 인라인 패널.
 *   - 뷰: compact = 카드 강제(테이블 토글 숨김).
 *   - 네비: compact = iOS large-title 헤더 + 하단탭("메뉴"=heritage Sidebar 모바일 sheet) / wide = 좌측 rail.
 * heritage `Sidebar` 모바일 경계는 `SidebarProvider mobileBreakpoint`(>=1.0.8) prop 으로 본 상수에 맞춰
 * sheet↔rail 전환을 정합시킨다(과거엔 heritage 하드코딩 768 때문에 768~1024 가 어긋났음).
 * 1024 채택 이유 = 인라인 필터 가로 배치는 태블릿 세로(768~1024)엔 좁아 1024 부터. (사용자 합의값.)
 */
export const COMPACT_MAX_WIDTH = 1024;
const QUERY = `(max-width: ${COMPACT_MAX_WIDTH - 1}px)`;

function subscribe(callback: () => void): () => void {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

/**
 * 화면이 compact(< lg) 인지. `useSyncExternalStore` 로 matchMedia 구독 —
 * effect-setState 없이 SSR 안전(서버 스냅샷=false). 프레젠테이션 전환(셸만 교체)에 쓰고, draft 상태는
 * 이 훅 위(feature)에 둬 전환 시 손실되지 않게 한다.
 */
export function useIsCompact(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
